import type { VoidFunctionComponent } from 'react';

/**
 * SnippetsContainer - Route container component for the Snippet Scanning page within a project.
 */
const SnippetsContainer: VoidFunctionComponent = () => {
  return (
    <div>
      <h1>Snippets - Coming soon to a project near you!</h1>
    </div>
  );
};

export default SnippetsContainer;
